import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }));
  
export default function LoaderWithProgress(props) {
    const classes = useStyles();
    const { size, thickness, styleLoader, styleContent, styleRoot, isContent, isLoader} = props;


    return (
        <div id='loader' className={`${classes.root} loading-progress`} style={{...styleRoot, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {isContent && 
                <Typography style={{...styleContent}}>Loading..</Typography>
            }
            {isLoader &&
                <CircularProgress 
                size={size ? size : 40} 
                thickness={thickness ? thickness : 3.6} 
                style={{...styleLoader}}/>
            }
        </div>
    )
}